import React, { useState } from "react";
import "./Overview.scss";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import expandIcon from "@assets/icons/Expand.svg";
import collapseIcon from "@assets/icons/Collapse.svg";
import currencyIcon from "@assets/icons/currency-dollar1.svg";
import avatar1 from "@assets/MockAvatar/mock1.png";
import avatar2 from "@assets/MockAvatar/mock2.png";
import avatar3 from "@assets/MockAvatar/mock3.png";
import avatar4 from "@assets/MockAvatar/mock4.png";
import avatar5 from "@assets/MockAvatar/mock5.png";
import avatar6 from "@assets/MockAvatar/mock6.png";
import avatar7 from "@assets/MockAvatar/mock7.png";
import AnalyticBox from "@components/AnalyticBox/AnalyticBox";
import ProducerHubFilter from "@components/ProducerHubFilter/ProducerHubFilter";
import StatisBar from "@components/StatisBar/StatisBar";
import { Row, Col, Select, Button, Divider, Tabs } from "antd";
import Helpers from "@utils/Helpers";
import { useUnit } from "contexts/UnitContext";

const Overview: React.FC = () => {
  const { units } = useUnit();
  const isLeaderboardVisible = false;
  const [isExpand, setIsExpand] = useState({
    chart: false,
    leaderboard: false,
  });
  const [selectedAnalysBox, setSelectedAnalysBox] = useState(1);
  const [selectedOption, setSelectedOption] = useState({
    date: 1,
    currency: 1,
    list: 1,
  });

  const userRanking = [
    {
      id: 1,
      profileName: "Witty-Daniel-Brandon-0234",
      value: 4000,
      avatar: Helpers.getImageFrontPage("store1"),
    },
    {
      id: 2,
      profileName: "Unique-Alexander-St. Albert-0012",
      value: 4500,
      avatar: Helpers.getImageFrontPage("store2"),
    },
    {
      id: 3,
      profileName: "Zealous-Grace-Steinbach-0034",
      value: 3700,
      avatar: Helpers.getImageFrontPage("store3"),
    },
  ];

  const usersList = [
    {
      id: 1,
      name: "Adventurous-Henry-Thompson-0912",
      avatar: avatar1,
      growthValue: null,
      isIncrease: null,
      balance: 3500,
    },
    {
      id: 2,
      name: "Creative-Scarlett-Selkirk-0214",
      avatar: avatar2,
      growthValue: 2.3,
      isIncrease: true,
      balance: 3200,
    },
    {
      id: 3,
      name: "You",
      avatar: avatar3,
      growthValue: 1.7,
      isIncrease: false,
      balance: 3000,
    },
    {
      id: 4,
      name: "Dynamic-Jackson-Winkler-0025",
      avatar: avatar4,
      growthValue: 8.2,
      isIncrease: true,
      balance: 2900,
    },
    {
      id: 5,
      name: "Enthusiastic-Lily-Flin Flon-0063",
      avatar: avatar5,
      growthValue: null,
      isIncrease: null,
      balance: 2500,
    },
    {
      id: 6,
      name: "Fearless-Samuel-Morden-0185",
      avatar: avatar6,
      growthValue: 5.1,
      increase: true,
      balance: 2000,
    },
    {
      id: 7,
      name: "Gracious-Aria-Portage la Prairie-0073",
      avatar: avatar7,
      growthValue: 2.9,
      increase: false,
      balance: 1000,
    },
  ];

  const analyticBox = [
    {
      id: 1,
      title: "Income",
      value: "1485.52",
      isIncrease: true,
      percent: "2.3%",
    },
    {
      id: 2,
      title: "All Products",
      value: "659",
      hayValue: "327",
      strawValue: "332",
      seedValue: "180",
    },
    {
      id: 3,
      title: "Orders",
      value: "2125",
      isIncrease: false,
      percent: "4.5%",
    },
    {
      id: 4,
      title: "Visitors",
      value: "1703",
      isIncrease: true,
      percent: "12.26%",
    },
    {
      id: 5,
      title: "Overall Rating",
      value: "4.0",
      isIncrease: true,
      percent: "17.6%",
    },
  ];

  const userTabs = ["Total sales", "Products", "Visitors", "Ratings"];

  return (
    <div className="Overview">
      <div className="producer-hub-content">
        <div className="producer-analytic-groups">
          {analyticBox.map((item, index) => {
            if (item.id !== 2) {
              return (
                <AnalyticBox
                  id={item.id}
                  title={item.title}
                  value={item.value}
                  isIncrease={item.isIncrease}
                  percent={item.percent}
                  selected={selectedAnalysBox === item.id}
                  setSelected={setSelectedAnalysBox}
                  key={index}
                />
              );
            }
            return (
              <AnalyticBox
                id={item.id}
                title={item.title}
                value={item.value}
                hayValue={item.hayValue}
                strawValue={item.strawValue}
                seedValue={item.seedValue}
                selected={selectedAnalysBox === item.id}
                setSelected={setSelectedAnalysBox}
                key={index}
              />
            );
          })}
        </div>
      </div>
      <div className="producer-content">
        <Row gutter={[14, 14]}>
          <Col
            span={
              isLeaderboardVisible
                ? isExpand.leaderboard
                  ? 9
                  : isExpand.chart
                    ? 15
                    : 12
                : 24
            }
          >
            <div className="content-item first-child">
              <div className="content-action">
                <Row align={`middle`}>
                  <Col span={12}>
                    <Select value={`income`}>
                      <Select.Option value="income">Income</Select.Option>
                      <Select.Option value="products">
                        All Products
                      </Select.Option>
                      <Select.Option value="orders">Orders</Select.Option>
                      <Select.Option value="visitors">Visitors</Select.Option>
                    </Select>
                  </Col>
                  <Col span={12}>
                    <div className="expand-group">
                      <Button
                        icon={
                          <img
                            src={isExpand.chart ? collapseIcon : expandIcon}
                            alt="expand"
                          />
                        }
                        color="default"
                        variant="link"
                        onClick={() => {
                          if (isExpand.chart) {
                            setIsExpand({
                              ...isExpand,
                              chart: !isExpand.chart,
                            });
                          } else {
                            setIsExpand({
                              ...isExpand,
                              chart: !isExpand.chart,
                              leaderboard: false,
                            });
                          }
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="content-value-group">
                <div className="value">
                  {analyticBox[selectedAnalysBox - 1].title === "Income"
                    ? "$" + analyticBox[selectedAnalysBox - 1].value
                    : analyticBox[selectedAnalysBox - 1].value}
                </div>
                {selectedAnalysBox === 2 ? (
                  <div className="categories">
                    <div className="category-item">
                      <div className="value">
                        {analyticBox[selectedAnalysBox - 1].hayValue}
                      </div>
                      <div className="name">Hay</div>
                    </div>
                    <Divider type="vertical" className="cate-divider" />
                    <div className="category-item">
                      <div className="value">
                        {analyticBox[selectedAnalysBox - 1].strawValue}
                      </div>
                      <div className="name">Straw</div>
                    </div>
                    <Divider type="vertical" className="cate-divider" />
                    <div className="category-item">
                      <div className="value">
                        {analyticBox[selectedAnalysBox - 1].seedValue}
                      </div>
                      <div className="name">Seed</div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      className={`growth-rate ${
                        analyticBox[selectedAnalysBox - 1].isIncrease
                          ? "increase"
                          : "decrease"
                      }`}
                    >
                      <div className="percent">
                        {analyticBox[selectedAnalysBox - 1].isIncrease ? (
                          <ArrowUpOutlined />
                        ) : (
                          <ArrowDownOutlined />
                        )}
                        <span>
                          {analyticBox[selectedAnalysBox - 1].percent}
                        </span>
                      </div>
                    </div>
                    <div className="in-time">
                      During 1 month <InfoCircleOutlined />
                    </div>
                  </>
                )}
              </div>
              <div className="statis-bar">
                <StatisBar selectedAnalysBox={selectedAnalysBox} />
              </div>
            </div>
          </Col>
          {isLeaderboardVisible && (
            <Col span={isExpand.chart ? 9 : isExpand.leaderboard ? 15 : 12}>
            <div className="content-item">
              <div className="content-action">
                <Row align={"middle"}>
                  <Col span={8}>
                    <Select value={`income`}>
                      <Select.Option value="income">Income</Select.Option>
                      <Select.Option value="products">
                        All Products
                      </Select.Option>
                      <Select.Option value="orders">Orders</Select.Option>
                      <Select.Option value="visitors">Visitors</Select.Option>
                    </Select>
                  </Col>
                  <Col span={8}>
                    <div className="content-title">
                      Leaderboard
                      <div className="content-date">Feb 02, 2025</div>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="expand-group">
                      <Button
                        className="expand-btn"
                        icon={
                          <img
                            src={
                              isExpand.leaderboard ? collapseIcon : expandIcon
                            }
                            alt="expand"
                          />
                        }
                        color="default"
                        variant="link"
                        onClick={() => {
                          if (isExpand.leaderboard) {
                            setIsExpand({
                              ...isExpand,
                              leaderboard: !isExpand.leaderboard,
                            });
                          } else {
                            setIsExpand({
                              ...isExpand,
                              chart: false,
                              leaderboard: !isExpand.leaderboard,
                            });
                          }
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="content-ranking">
                {userRanking.map((item, index) => {
                  return (
                    <div className="ranking-item" key={index}>
                      <div className="ranking-avatar">
                        <img
                          className="avatar"
                          src={item.avatar}
                          alt={item.profileName}
                        />
                      </div>
                      <div className="ranking-name">{item.profileName}</div>
                      <div className="ranking-value">
                        <img src={currencyIcon} alt={item.value.toString()} />
                        {item.value}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="content-users">
                <Tabs
                  type="card"
                  items={userTabs.map((item, i) => {
                    const id = String(i + 1);
                    return {
                      label: (
                        <div className="tab-label">
                          {item}
                          <InfoCircleOutlined />
                        </div>
                      ),
                      key: id,
                      children: (
                        <div className="leaderboard-list">
                          <div className="leaderboard-filters">
                            <ProducerHubFilter
                              selectedOption={selectedOption}
                              setSelectedOption={setSelectedOption}
                              isLeaderboard={true}
                            />
                          </div>
                          <div className="leaderboard-users">
                            {usersList.map((user: any, inx: number) => {
                              return (
                                <div
                                  className={`user-item ${
                                    user.name === "You" ? "highlight" : ""
                                  }`}
                                  key={inx}
                                >
                                  <div className="user-id">{user.id + 3}</div>
                                  <div className="user-avatar">
                                    <img src={user.avatar} alt={"avatar"} />
                                  </div>
                                  <div className="user-name">{user.name}</div>
                                  {user.growthValue == null ? (
                                    <div className="user-growth">-</div>
                                  ) : user.isIncrease === true ? (
                                    <div className="user-growth increase">
                                      <ArrowUpOutlined />{" "}
                                      <span>{user.growthValue}%</span>
                                    </div>
                                  ) : (
                                    <div className="user-growth decrease">
                                      <ArrowDownOutlined />
                                      <span>{user.growthValue}%</span>
                                    </div>
                                  )}
                                  <div className="user-balance">
                                    <img src={currencyIcon} alt="currency" />
                                    <span>{user.balance}</span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ),
                    };
                  })}
                />
              </div>
            </div>
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
};

export default Overview;
